import React from 'react'
import 'animate.css/animate.compat.css';
import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';
import Careers from './components/Careers';
import SkillDevelopment from './components/SkillDevelopment';
import Donation from './components/Donation';
import Gallery from './components/Gallery';
import PrivacyPolicy from './components/PrivacyPolicy';
import Login from './general/Login';
import Dashboard from './components/Dashboard';
import JobApplication from './components/JobApplication';
import AdminGallery from './components/AdminGallery';
import ScrollTop from './general/ScrollTop';
import Header from './general/Header';
import Footer from './general/Footer';
import AdminHeader from './general/AdminHeader';
import PageNotFound from './components/PageNotFound';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import DonationHistory from './components/DonationHistory';

const App = () => {

  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';

  return (
    <BrowserRouter>
      <ScrollTop />

      {!isLoggedIn && (<>
      <Header />
      <Routes>
        <Route exact path='/' element={<Home />} />
        <Route exact path='/about' element={<About />} />
        <Route exact path='/contact' element={<Contact />} />
        <Route exact path='/careers' element={<Careers />} />
        <Route exact path='/skill-development' element={<SkillDevelopment />} />
        <Route exact path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route exact path='/donation' element={<Donation />} />
        <Route exact path='/gallery' element={<Gallery />} />
        <Route exact path='/login' element={<Login />} />
        <Route exact path='*' element={<PageNotFound />} />
      </Routes>
      <Footer />
      </>
    )}

      {isLoggedIn && (
        <>
        <AdminHeader />
        <Routes>
        <Route exact path='/' element={<Dashboard />} />
        <Route exact path='/admin/dashboard' element={<Dashboard />} />
        <Route exact path='/admin/job-application' element={<JobApplication />} />
        <Route exact path='/admin/admin-gallery' element={<AdminGallery />} />
        <Route exact path='/admin/donation-history' element={<DonationHistory />} />
        <Route exact path='*' element={<PageNotFound />} />
        </Routes>
        </>
      )}

    </BrowserRouter>
  );
};

export default App;
